import {
  IUpdateGroupUsersCommand,
  UpdateGroupUsersCommand,
} from "@growth-machine-llc/stridist-api-client";
import { clientGroupsClient } from "../api/ApiClients";

import ServiceBase from "./ServiceBase";

class ClientGroupsService extends ServiceBase {
    async updateGroupMembers(data: IUpdateGroupUsersCommand) {
        const command = UpdateGroupUsersCommand.fromJS(data);
        return clientGroupsClient.updateGroupUsers(command);
    }

    async removeGroupMember(groupId: number, clientId: number) {
        return clientGroupsClient.removeGroupMember(groupId, clientId);
    }
}

export default new ClientGroupsService();
